module.exports = __webpack_public_path__ + "static/media/4.f2914e99.mp3";